<template>
  <div class="alert" v-if="message" :class="[message.type]">
    <div class="wrapper">
      <div class="icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
          v-if="message.type === 'error'"
        >
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clip-rule="evenodd"
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
          v-if="message.type === 'success'"
        >
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clip-rule="evenodd"
          />
        </svg>
        <svg
          class="w-6 h-6"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          v-if="message.type === 'info'"
        >
          <path
            fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </div>
      <div class="text">{{ message.content }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    message: Object,
  },
};
</script>

<style scoped>
.alert {
  @apply mb-4 px-4 py-3 rounded-md;

  &.error {
    @apply bg-red-50;

    .text {
      @apply text-red-700;
    }

    svg {
      @apply text-red-400;
    }
  }

  &.success {
    @apply bg-green-50;

    .text {
      @apply text-green-700;
    }

    svg {
      @apply text-green-400;
    }
  }

  &.info {
    @apply bg-blue-50;

    .text {
      @apply text-blue-700;
    }

    svg {
      @apply text-blue-400;
    }
  }
}

.wrapper {
  @apply flex;
}

.icon {
  @apply flex-shrink-0;
}

.text {
  @apply ml-3 text-red-700;
}

svg {
  @apply h-5 w-5 text-red-400;
}
</style>
